import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { TitleComponent } from './title.component';

@NgModule({
  declarations: [TitleComponent],
  imports: [CommonModule, SharedModule],
  exports: [TitleComponent]
})
export class TitleModule {}
